import { EstensaColDef } from '../search-param.model';
import { TranslateService } from '@ngx-translate/core';
import { GridUtilitiesService } from '../../services/grid-utilities.service';
import { IconType } from '@se/cp.common';

export function visitColumnDefs(translate: TranslateService, gridUtils: GridUtilitiesService): EstensaColDef[] {
    return [
        {
            colId: 'lockColId',
            headerName: '',
            tooltipField: '',
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px' },
            cellRenderer: 'lockUnlockRenderer',
            cellRendererParams: {
                lockedField: 'locked',
                userField: 'lockedUserFullName',
            },
        },
        {
            colId: 'ExamOutOfFlow',
            headerName: '',
            valueGetter: (e) => e.data,
            tooltipField: '',
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: true,
            comparator: (valueA, valueB) => {
                if (valueA.patient.isLocalPatient && valueB.patient.isLocalPatient) return 0;
                if (!valueA.patient.isLocalPatient && !valueB.patient.isLocalPatient) return 0;
                if (!valueA.patient.isLocalPatient && valueB.patient.isLocalPatient) return 1;

                return -1;
            },
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px' },
            cellRenderer: 'stateIconRenderer',
            cellRendererParams: {
                estensa: [
                    {
                        iconType: IconType.SeFont,
                        field: 'patient.isLocalPatient',
                        icon: 'icon_flusso_inverso',
                        tooltip: 'PatientDataNotAssociated',
                    },
                    {
                        iconType: IconType.AngularMaterial,
                        field: 'reportingWithoutTrace',
                        icon: 'image_not_supported',
                        fontSize: '18px',
                        tooltip: 'ExamWithoutTrace',
                    },
                    {
                        iconType: IconType.AngularMaterial,
                        field: 'fromIntegration',
                        icon: 'exit_to_app',
                        fontSize: '18px',
                        tooltip: 'ExternalIntegration',
                    },
                ],
            },
        },
        {
            colId: 'AssociatedVisit',
            headerName: '',
            valueGetter: (e) => e.data,
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px' },
            cellRenderer: 'associatedVisitsRenderer',
            cellRendererParams: (params: any) => {
                return params;
            },
        },
        {
            colId: 'SameStudy',
            headerName: '',
            valueGetter: (e) => e.data,
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px' },
            cellRenderer: 'sameStudyRenderer',
            cellRendererParams: (params: any) => {
                return params;
            },
        },
        {
            colId: 'AttachedDocuments',
            headerName: '',
            valueGetter: (e) => e.data.hasAttachedDocuments || e.data.hasAttachedDdevices,
            width: 26,
            minWidth: 26,
            suppressSizeToFit: true,
            resizable: false,
            sortable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', width: '26px' },
            cellRenderer: 'boolIconRenderer',
            cellRendererParams: (params: any) => {
                return {
                    estensa: {
                        iconType: IconType.AngularMaterial,
                        icon: 'file_present',
                        tooltip: getTooltip(params.data, translate)
                    }
                };
            }
        },
        {
            colId: '0',
            headerName: translate.instant('Patient'),
            headerTooltip: translate.instant('Patient'),
            valueGetter: (e) => {
                const lastName = e.data.patient.lastName ?? '';
                const firstName = e.data.patient.firstName ?? '';
                return `${lastName.toLocaleUpperCase()} ${firstName.toLocaleUpperCase()}`;
            },
            tooltipValueGetter: (e) => {
                const lastName = e.data.patient.lastName ?? '';
                const firstName = e.data.patient.firstName ?? '';
                return `${lastName.toLocaleUpperCase()} ${firstName.toLocaleUpperCase()}`;
            },
            width: 220,
            minWidth: 220,
            suppressSizeToFit: true,
            lockPosition: true,
            pinned: 'left',
            cellStyle: (e) => {
                if (e.data.patient.isCertificating === true) return { 'background-color': 'yellow', color: 'black' };
                if (e.data.patient.isCertificating === false && e.data.patient.isCertified === false)
                    return { 'background-color': 'red', color: 'black' };
                return null;
            },
        },
        {
            colId: '1',
            headerName: translate.instant('BirthDate'),
            headerTooltip: translate.instant('BirthDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'patient.birthDate',
            width: 180,
            minWidth: 180,
            valueFormatter: gridUtils.dateFormatter(['patient', 'birthDate']),
            comparator: gridUtils.dateComparator,
        },
        {
            headerName: translate.instant('ExamDate'),
            headerTooltip: translate.instant('ExamDate'),
            field: 'examinationDate',
            colId: '2',
            width: 150,
            minWidth: 150,
            sort: 'desc',
            valueFormatter: gridUtils.dateTimeFormatter('examinationDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
            tooltipValueGetter: (p) => p.valueFormatted,
        },
        {
            headerName: translate.instant('ReportDate'),
            headerTooltip: translate.instant('ReportDate'),
            field: 'reportDate',
            colId: '3',
            width: 150,
            minWidth: 150,
            valueFormatter: gridUtils.dateTimeFormatter('reportDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
        },
        // {
        //     headerName: translate.instant('ReferringPhysician'),
        //     headerTooltip: translate.instant('ReferringPhysician'),
        //     valueGetter: e => gridUtils.getFullName(e.data.referringPhysician),
        //     tooltipValueGetter: e => gridUtils.getFullName(e.data.referringPhysician),
        //     colId: '4',
        //     width: 220,
        //     minWidth: 190,
        //     suppressSizeToFit: false,
        //     hide: false,
        // },
        {
            headerName: translate.instant('ReferringPhysician'),
            headerTooltip: translate.instant('ReferringPhysician'),
            tooltipField: 'referringPhysicianFullNameList',
            field: 'referringPhysicianFullNameList',
            colId: '4',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('ExamNumber'),
            headerTooltip: translate.instant('ExamNumber'),
            tooltipField: 'examNumber',
            field: 'examNumber',
            colId: '5',
            width: 190,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '6',
            headerName: translate.instant('Accession_Number'),
            headerTooltip: translate.instant('Accession_Number'),
            field: 'accessionNumber',
            width: 190,
            minWidth: 190,
        },
        {
            headerName: translate.instant('Exam'),
            headerTooltip: translate.instant('Exam'),
            tooltipField: 'exam.description',
            field: 'exam.description',
            colId: '7',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('BusinessUnit'),
            headerTooltip: translate.instant('BusinessUnit'),
            tooltipField: 'businessUnit.description',
            field: 'businessUnit.description',
            colId: '8',
            width: 190,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Status'),
            headerTooltip: translate.instant('Status'),
            tooltipField: 'status',
            field: 'status',
            colId: '9',
            width: 80,
            minWidth: 80,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Severity'),
            headerTooltip: translate.instant('Severity'),
            tooltipField: 'severity.description',
            field: 'severity.description',
            cellStyle: (params) => ({
                color:
                    params.data.severity?.color?.toLocaleLowerCase() == 'white'
                        ? 'black'
                        : params.data.severity?.color?.toLocaleLowerCase(),
            }),
            colId: '10',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('Provenance'),
            headerTooltip: translate.instant('Provenance'),
            tooltipField: 'provenance.description',
            field: 'provenance.description',
            colId: '11',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            headerName: translate.instant('GroupProvenance'),
            headerTooltip: translate.instant('GroupProvenance'),
            tooltipField: 'provenance.groupProvenance.description',
            field: 'provenance.groupProvenance.description',
            colId: '12',
            width: 150,
            minWidth: 150,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '13',
            headerName: translate.instant('PatientId'),
            headerTooltip: translate.instant('PatientId'),
            tooltipField: 'patient.patientId',
            field: 'patient.patientId',
            width: 190,
            minWidth: 190,
        },
        {
            headerName: translate.instant('OtherPatientId'),
            headerTooltip: translate.instant('OtherPatientId'),
            tooltipField: 'patient.otherPatientId',
            field: 'patient.otherPatientId',
            colId: '14',
            width: 190,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '15',
            headerName: translate.instant('ReportLocalId'),
            headerTooltip: translate.instant('ReportLocalId'),
            tooltipField: 'localId',
            field: 'localId',
            width: 100,
            minWidth: 100,
        },
    ];
}

export function getTooltip(params: any, translate: TranslateService): string {
    if (params.hasAttachedDocuments && params.hasAttachedDdevices) {
        return translate.instant('DocumentsAndDevicesAttached');
    }
    else if (params.hasAttachedDocuments) {
        return translate.instant('AttachedDocuments');
    }
    else if (params.hasAttachedDdevices) {
        return translate.instant('AttachedDevices');
    } else {
        return '';
    }
}
